export default "__VITE_ASSET__e47daf9e__"